import React, { Component } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import './RefSetSearchBar.css';


class RefSetSearchBar extends Component {
	static contextType = GlobalContext;

	constructor(props) {
		super(props);
		this.state = {
			refSetQuery: '',
			refSetTotal: 0
		};

		this.handleInputChange = this.handleInputChange.bind(this);
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.value;

		this.setState({
			refSetQuery: value,
		});

		// this.setState({
		// 	refSetTotal: this.props.getCounter(),
		// });

		const { setRefSetQuery } = this.context;
		setRefSetQuery(value);
	}

	render() {
		return (
			<div className="RefSetSearchBar">
				<div className="RefSetSearchBar__left">
					Search
				</div>
				<div className="RefSetSearchBar__middle">
					<input
						type="search"
						autoComplete="off"
						onChange={this.handleInputChange}
						value={this.state.refSetQuery}
						className="RefSetSearchBar__search"
					/>
				</div>
				<div className="RefSetSearchBar__right">
					{this.context.refSetFilterCount} / {this.context.refsetCount}
				</div>
			</div>
		);
	}
}

export default RefSetSearchBar;